export type ImportFolder = {
  name: string;
  parentid: number;
  secToken: number;
  shortcut: boolean;
  idstemplate: boolean;
  pdstemplate: boolean;
  childrenLoaded: boolean;
  readAllowed: boolean;
  writeAllowed: boolean;
  system: boolean;
  addPedSec: number | null;
  delPedSec: number | null;
  modPedSec: number | null;
  readPedSec: number | null;
  writePedSec: number | null;
  context: number;
  hasChildren: boolean;
  id: number;
  children: ImportFolder[] | null;
  imageURL: string;
  childrenForDisplay: ImportFolder[] | null;
  imageURLSelected: string;
  wdcfolder: boolean;
  wdcenabled: boolean;
  folderReadSec: number | null;
};

export type ImportField = {
  fieldid: number;
  fieldname: string;
  fieldtype?: {
    typeid: number;
    typename: string;
    computed?: boolean;
    fieldClass?: string;
    imageURL?: string;
    systemType?: boolean;
  };
  permissions?: string;
  tableIndex?: number;
  defaultWidth?: number;
  fieldcontext: string;
  table?: boolean;
  calcField?: boolean;
  computed?: boolean;
  fieldClass?: string;
  imageURL: string;
  lookupTableInfo?: unknown;
  updateColsCount?: number;
  showEditorAllowed?: boolean;
  showUploadAllowed?: boolean;
  autoEditOnClick?: boolean;
  hyperlinkfield?: boolean;
  imageField?: boolean;
  fieldnameWithPath?: string;
  systemDateField?: boolean;
  updateFieldname?: string;
  confirmEntry?: boolean;
  tableSubField?: boolean;
  dataSourceNodeId?: number;
  remoteField?: boolean;
  remoteFieldName?: string | null;
  remoteTableName?: string;
  remoteTableKeyField?: string;
  rawFieldType?: number;
  required?: boolean;
  systemField: boolean;
  remoteTableRowIdentifierFieldname?: string;
  localMatchForRemoteKeyField?: string | null;
  type: number;
};

export type CheckImportFileResult = {
  pedigreeFolders: ImportFolder[];
  individualFolders: ImportFolder[];
  systemFields: Record<string, ImportField[]>;
  pedigreeFields: Record<string, ImportField[]>;
  individualFields: Record<string, ImportField[]>;
  systemSubTextFields: boolean;
  formatContext: number;
  formatName: string;
  tableFieldId: number;
  // Use formatContext as context for backward compatibility
  context: number;
};

export const checkImportFile = async (file: File): Promise<CheckImportFileResult> => {
  const formData = new FormData();
  formData.append("fileData", file);

  const response = await fetch("api/datasheet/checkImportFile", {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    let message = `Failed to check import file: ${response.status} ${response.statusText}`;
    try {
      const textBody = await response.text();
      if (textBody) {
        message = textBody;
      }
    } catch {
      // ignore parsing errors and fall back to default message
    }
    throw new Error(message);
  }

  // Parse JSON response
  const data = await response.json();

  // Use formatContext as context
  return {
    ...data,
    context: data.formatContext || 1,
  };
};

export type ImportDatasheetSettings = {
  folderId: number;
  pedFieldIds: number[];
  indFieldIds: number[];
  createFields: boolean;
};

export const importDatasheetFormat = async (
  file: File,
  settings: ImportDatasheetSettings
): Promise<unknown> => {
  const formData = new FormData();
  formData.append("fileData", file);
  formData.append(
    "settings",
    JSON.stringify({
      folderId: settings.folderId,
      pedFieldIds: settings.pedFieldIds,
      indFieldIds: settings.indFieldIds,
      createFields: settings.createFields,
    })
  );

  const response = await fetch("api/datasheet/import", {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    let message = `Failed to import datasheet format: ${response.status} ${response.statusText}`;
    try {
      const textBody = await response.text();
      if (textBody) {
        message = textBody;
      }
    } catch {
      // ignore parsing errors and fall back to default message
    }
    throw new Error(message);
  }

  try {
    return await response.json();
  } catch {
    return await response.text();
  }
};



